import '.an{max-width:1280px;}.ssr-plugin'
import '.ap{margin:0 auto;}.ssr-plugin'
import '.e{display:flex;}.ssr-plugin'
import '.m{width:100%;}.ssr-plugin'
import '.ao{justify-content:space-between;}.ssr-plugin'
import '.bj{gap:144px;}.ssr-plugin'
import '.bk{max-width:568px;}.ssr-plugin'
import '.bl{margin-bottom:16px;}.ssr-plugin'
import '.bm{margin-bottom:48px;}.ssr-plugin'
import '.bo{text-align:left;}.ssr-plugin'
import { styled } from 'inlines'
import { Layout } from '../../components/Layout.js'
import { colors } from '../../utils/colors.js'
import { useTrack } from '../../hooks/useTrack.js'
import { AnalyticsEvent } from '../../../../shared/analyticsEvents.js'
import { TABLET } from '../../utils/breakpoints.js'
import { useLanguage } from '../../hooks/useLanguage.js'
import { useDictionary } from '../../hooks/useDictionary.js'
import { useEffect } from 'react'
import { useContentQuery } from '../../ctx.js'
import { useScrollToTop } from '../../hooks/useScrollToTop.js'

export const VotingIntegrity = () => {
  const track = useTrack('voting-integrity')

  const [lang] = useLanguage()

  const { legalGroupTitle, votingIntegrity, moreInfoReachOut } = useDictionary()
  const { data: info } = useContentQuery('info', null, true)

  useScrollToTop()

  useEffect(() => {
    track(AnalyticsEvent.PAGE_LOAD)
  }, [])

  return (
    <Layout>
      <styled.div className="an ap e m ao bj"
        style={{
          [TABLET]: {
            flexDirection: 'column',
            gap: '72px',
          },
        }}
      >
        {/* column 1 */}
        <styled.div className="bk"
          style={{
            textAlign: lang.rtl ? 'right' : 'left',
            [TABLET]: {
              maxWidth: 'none',
            },
          }}
        >
          <h3 className="bl">{legalGroupTitle}</h3>
          <h2 className="bm" style={{ color: colors.primary,}}>
            {votingIntegrity}
          </h2>
        </styled.div>
        {/* column 2 */}
        <styled.div className="bo bk"
          style={{
            '& p': {
              margin: '1em 0em',
            },
            [TABLET]: {
              maxWidth: 'none',
            },
          }}
          dangerouslySetInnerHTML={{
            __html: typeof info === 'string' ? info : '',
          }}
        ></styled.div>
      </styled.div>
    </Layout>
  )
}
